export default function Footer() {
    return (
        <div className={"flex items-center justify-center"}>
            <span className={"font-monospace dark-slate text-xs lg:text-sm p-8 text-center"}>
                © 2025 Tejas Naik — AI Web Developer · SaaS Builder · Coding Educator
            </span>
        </div>
    )
}
